import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-cinema-surface mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-cinema-muted">
        <div>
          © {new Date().getFullYear()} CinemaKE — Kenyan cinema discovery
        </div>
        <div className="flex items-center gap-4">
          <Link to="/privacy" className="hover:text-cinema-gold">
            Privacy
          </Link>
          <a
            href="https://github.com/boxcode254/CinemaKE"
            target="_blank"
            rel="noreferrer noopener"
            className="hover:text-cinema-gold"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
}
